import { clientReloadInterceptor } from "@faire/web--source/common/requests/response-interceptors/clientReloadInterceptor";
import { errorLoggingInterceptor } from "@faire/web--source/common/requests/response-interceptors/errorLoggingInterceptor";
import { ResponseInterceptor } from "@faire/web-api--source/types";

export const responseInterceptors: ReadonlyArray<ResponseInterceptor> =
  Object.freeze([errorLoggingInterceptor, clientReloadInterceptor]);
